// Standard form field styles used across the app
export const sectionInputStyles = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "black",
      borderRadius: "15px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#E1A731",
    },
  },
};

// Variant used in discount forms with a muted focused border color
export const sectionInputStylesMutedFocus = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "black",
      borderRadius: "15px",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0000008a",
    },
  },
};
